<template>
  <div>
    <select
      id="states"
      class="select-states">
      <option
        value="-"
        disabled
        selected>Todos los estados</option>
      <option value="Aguascalientes">Aguascalientes</option>
      <option value="Baja_California">Baja California</option>
      <option value="Baja California Sur">Baja California Sur</option>
      <option value="Campeche">Campeche</option>
      <option value="Chiapas">Chiapas</option>
      <option value="Chihuahua">Chihuahua</option>
      <option value="Coahuila">Coahuila</option>
      <option value="Colima">Colima</option>
      <option value="Durango">Durango</option>
      <option value="Estado de México">Estado de México</option>
      <option value="Guanajuato">Guanajuato</option>
      <option value="Guerrero">Guerrero</option>
      <option value="Hidalgo">Hidalgo</option>
      <option value="Jalisco">Jalisco</option>
      <option value="Michoacán">Michoacán</option>
      <option value="Morelos">Morelos</option>
      <option value="Nuevo_Leon">Nuevo Leon</option>
      <option value="Oaxaca">Oaxaca</option>
      <option value="Puebla">Puebla</option>
      <option value="Querétaro">Querétaro</option>
      <option value="Quintana_Roo">Quintana Roo</option>
      <option value="San_Luis_Potosi">San Luis Potosi</option>
      <option value="Sinaloa">Sinaloa</option>
      <option value="Sonora">Sonora</option>
      <option value="Tabasco">Tabasco</option>
      <option value="Tamaulipas">Tamaulipas</option>
      <option value="Tlaxcala">Tlaxcala</option>
      <option value="Veracruz">Veracruz</option>
      <option value="Yucatán">Yucatán</option>
      <option value="Zacatecas">Zacatecas</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'MtSelectStates'
}
</script>

<style lang="scss" scoped>
  .select-states{
    -webkit-appearance: none;
    padding-left: 10px;
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 2px !important;
    background-color: white;
    font-size: 14px;
  }
option{
  &:before{
    content: "/";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-select-states.vue